import { render } from "./MenuManagement.vue?vue&type=template&id=1cf0febc&ts=true"
import script from "./MenuManagement.vue?vue&type=script&lang=ts"
export * from "./MenuManagement.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/MenuManagement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1cf0febc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1cf0febc', __exports__)) {
    api.reload('1cf0febc', __exports__)
  }
  
  module.hot.accept("./MenuManagement.vue?vue&type=template&id=1cf0febc&ts=true", () => {
    api.rerender('1cf0febc', render)
  })

}


export default __exports__